export interface ISharedModel {
  name: string;
  code: number;
}

export interface IGender extends ISharedModel {}

export interface IMilitaryStatus extends ISharedModel {}

export interface IEducationalGrade extends ISharedModel {}

export interface IEnglishKnowledge extends ISharedModel {}

export interface IWorkExperience extends ISharedModel {}

export interface IHasConsentLetter {
  name: string;
  value: boolean;
}

export interface IMonth extends ISharedModel {}

export interface IDate {
  days: number;
  months: number;
  years: number;
}

export interface ICertifChecks {
  description: string;
  value: boolean;
  code: number;
}

export interface IApplyJob {
  personalInfo: IPersonalInfo;
  education: IEducationOInfo;
  workExperienceDetail?: IWorkExperienceDetail;
  description: string;
}

interface IWorkExperienceDetail {
  availability: string;
  job1: IJobDescription;
  job2: IJobDescription;
}

interface IJobDescription {
  companyName: string;
  lastJobLocation: string;
  fieldOfActivity: string;
  jobTitle: string;
  startDate: IDate;
  endDate: IDate;
  reasonYouLeft?: string;
  consentLetter: boolean;
}

interface IPersonalInfo {
  gender: string;
  firstName: string;
  lastName: string;
  birthDate: IDate;
  placeOfBirth: string;
  nationalCode: number;
  marriageStatus: string;
  militaryStatus?: string;
  cityOfResidence: string;
  neighborhood: string;
  phoneNumber: number;
  email: string;
}

interface IEducationOInfo {
  lastDegree: string;
  major: string;
  nameOfFacility: string;
  facilityLocation: string;
  graduationDate: IDate;
  stockCertificate?: ICertifChecks;
  otherCertificates?: string;
  englishKnowledge: string;
}

export enum ConsultingServiceTypeEnum {
  CONSULTING = 1,
  NON_PRESENCE_INVETMENT = 2,
  INVESTMENT_WITH_APPOINTMENT = 3,
}

export enum ConsultingServiceTitleEnum {
  INVESTMENT_MANAGEMENT = 1,
  FUNDS_MANAGEMENT = 2,
}
export enum ConsultingServiceFundEnum {
  ABAN_YEKOM = 1,
  PARS = 2,
  NEDAYE_OMID = 3,
  ROSHD = 4,
  KOSAR = 5,
}
